// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o2yw","col":"styles_col__3fusZ"};